module.exports = __webpack_public_path__ + "static/media/code.bf3121ad.svg";